import axiosInstance from '@/store/axios'
import { rejectError } from '@/store/helper'

export default {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    users ({ commit }, params) {
      return axiosInstance.get('/api/v1/users', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
  },
}
